import { isPlatformBrowser } from '@angular/common';
import { BrowserWindowReference } from './browser-window-reference';

export function windowFactory(
  browserWindowRef: BrowserWindowReference,
  platformId: Record<string, unknown>,
): Window | Record<string, unknown> {
  if (isPlatformBrowser(platformId)) {
    return browserWindowRef.nativeWindow;
  }

  return {};
}
